import { defineComponent as _defineComponent } from 'vue'
import { flattenDeep, dayjs } from "~/utils/helpers";
import { computed } from "@nuxtjs/composition-api";
import type { Dayjs, ConfigType as ValueType } from "dayjs";


export default /*#__PURE__*/_defineComponent({
  __name: 'stock-calendar',
  props: {
    today: { default: () => new Date() },
    selected: { default: () => null },
    weekStart: { default: 1 },
    months: { default: () => [] },
    month: null,
    value: { default: () => new Date() }
  },
  emits: ["update:month", "month-change"],
  setup(__props: any, { emit }: { emit: ({
  (e: "update:month", month: string): void;
  (e: "month-change", month: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { today: Date, selected: ValueType, weekStart: 0 | 1 | 2 | 3 | 4 | 5 | 6, months: string[], month?: string, value: ValueType }

const DATE_COL_COUNT = 7;
const DATE_ROW_COUNT = 6;




// const onMonthItemClick = (month: string) => {
//   if (props.month === month) {
//     return;
//   }

//   emit("update:month", month);
//   emit("month-change", month);
// };

// const getDefaultDate = () => {
//   return flattenDeep([props.selected])[0] || props.today;
// };
// const realWeekStart = computed(() => {
//   return props.weekStart !== null ? props.weekStart : 0;
// });

const realSelected = computed(() => {
  return flattenDeep([props.selected]);
});
// const current = ref(getDefaultDate());
const dayNames = computed(() => {
  let localeData = dayjs(props.value).localeData();
  const firstDayOfWeek = localeData.firstDayOfWeek();
  const now = dayjs();
  let names = [];
  for (let i = 0; i < DATE_COL_COUNT; i++) {
    const index = (firstDayOfWeek + i) % DATE_COL_COUNT;
    now.day(index);

    names.push({
      day: index,
      label: localeData.weekdaysMin(now.day(index)),
      isWeekday: [0, 6].includes(index),
    })
    // console.log('weekdaysMin', localeData.weekdaysMin(now.day(index)))
  }
  return names;
});
const weeks = computed(() => {
  const currentDayjs = dayjs(props.value);
  // console.log("currentDayjs", currentDayjs.format("YYYY-MM-DD"));
  let _curr: Dayjs;
  let month = currentDayjs.clone().date(1);

  let day = month.day();
  let lastMonthDiffDay = (day + 7 - month.localeData().firstDayOfWeek()) % 7;
  let lastMonth = month.clone().subtract(lastMonthDiffDay, "d");
  lastMonth.add(0 - lastMonthDiffDay, "days");
  const weeks = [];
  let passed = 0;

  for (let iIndex = 0; iIndex < DATE_ROW_COUNT; iIndex++) {
    const cells = [];

    for (let jIndex = 0; jIndex < DATE_COL_COUNT; jIndex++) {
      _curr = lastMonth;
      if (passed) {
        _curr = _curr.clone().add(passed, "d");
        // console.log(_curr.format('YYYY-MM-DD'), passed)
      }

      let disabled = passed % 3 === 0;
      let selected = realSelected.value.some((item) => dayjs(item).isSame(_curr, "day"));
      cells.push({
        disabled,
        selected,
        isInView: _curr.isSame(props.value, 'month'),
        month: _curr.get("month"),
        year: _curr.get("year"),
        date: _curr.toDate(),
      });

      passed++;
    }

    weeks.push(cells);
  }
  return weeks;
});

return { __sfc: true,DATE_COL_COUNT, DATE_ROW_COUNT, props, emit, realSelected, dayNames, weeks }
}

})